module.exports = __webpack_public_path__ + "6a1f690cbf4e911e4cb164e19da1c36b.svg";